import React, { useState, useEffect } from 'react';
import { Box, Typography, Button } from '@mui/material';
import CookieIcon from '@mui/icons-material/Cookie';

const STORAGE_KEY = 'usafiri_cookie_consent';

export default function CookieConsent() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const handle = (choice) => {
    localStorage.setItem(STORAGE_KEY, choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box sx={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, width: { xs: 'calc(100% - 32px)', sm: 480 },
      bgcolor: '#1a1a1a', borderRadius: '16px',
      p: 2.5, boxShadow: '0 8px 32px rgba(0,0,0,0.3)',
      display: 'flex', flexDirection: { xs: 'column', sm: 'row' },
      alignItems: { xs: 'flex-start', sm: 'center' }, gap: 2,
    }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, flex: 1 }}>
        <CookieIcon sx={{ color: '#FDB927', fontSize: 22, flexShrink: 0, mt: 0.2 }} />
        <Box>
          <Typography sx={{ color: '#fff', fontWeight: 700, fontSize: '0.88rem', mb: 0.3 }}>
            Cookies
          </Typography>
          <Typography sx={{ color: 'rgba(255,255,255,0.6)', fontSize: '0.78rem', lineHeight: 1.4 }}>
            Nous utilisons des cookies pour améliorer votre expérience et analyser le trafic.
          </Typography>
        </Box>
      </Box>

      <Box sx={{ display: 'flex', gap: 1, flexShrink: 0, alignSelf: { xs: 'stretch', sm: 'auto' } }}>
        <Button
          onClick={() => handle('refused')}
          sx={{
            flex: { xs: 1, sm: 'auto' },
            color: 'rgba(255,255,255,0.6)', fontSize: '0.82rem', fontWeight: 600,
            textTransform: 'none', border: '1px solid rgba(255,255,255,0.15)',
            borderRadius: '10px', px: 2, py: 0.8,
            '&:hover': { bgcolor: 'rgba(255,255,255,0.06)', borderColor: 'rgba(255,255,255,0.3)' },
          }}
        >
          Refuser
        </Button>
        <Button
          onClick={() => handle('accepted')}
          sx={{
            flex: { xs: 1, sm: 'auto' },
            bgcolor: '#552583', color: '#fff', fontSize: '0.82rem', fontWeight: 700,
            textTransform: 'none', borderRadius: '10px', px: 2, py: 0.8,
            '&:hover': { bgcolor: '#3d1a61' },
          }}
        >
          Accepter
        </Button>
      </Box>
    </Box>
  );
}
